<template>
  <div class="right dn-content-bg zt">
    <div class="half">
      <div class="title-wrap zt">
        <div class="flex-1 title-content">横向表头</div>
        <div style="flex: 0 0 130px;">
          <el-button type="primary" icon="el-icon-circle-plus" @click="addRight">新增</el-button>
        </div>
      </div>
      <div class="list1 zt">
        <div class="item" v-for="(item, index) in columnsData" :key="index" :class="isCloumn == index ? 'item btn' : 'item'" @click="selectCloumn(index)">
          <div class="item-title" :title="item.tiel">{{ item.title }}</div>
          <el-button type="text" icon="el-icon-edit" title="修改" @click="modifyRight(item, index)" :class="isCloumn == index ? 'black' : ''"></el-button>
          <el-button type="text" icon="el-icon-delete" title="删除" @click="deleteTable('right', index)" :class="isCloumn == index ? 'black' : ''"></el-button>
        </div>
      </div>
      <!-- 右边表格新增编辑开始 -->
      <el-dialog :title="rightTitle" :visible.sync="showRight" width="1100px" :close-on-click-modal="false">
        <div style="maxHeight">
          <div style="display: flex" class="rows" v-for="(items, index) in rightFormData" :key="index">
            <span style="margin-right: 5px">表头:</span>
            <el-input v-model="items.title" style="width: 250px" placeholder="表头名称"></el-input>
            <span style="margin: 0 5px 0 5px">数据类型:</span>
            <el-select v-model="items.dataType" placeholder="请选择" clearable @change="changeData(index, $event)">
              <el-option v-for="(item, index) in datasType" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span style="margin: 0 5px 0 5px">数据项:</span>
            <el-select style="width: 200px" v-model="items.type" placeholder="请选择" clearable v-if="items.dataType == 1" @change="changeColle(index, $event)">
              <el-option v-for="(item, index) in tableType" :key="index" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <el-input v-model="items.type" style="width: 200px" placeholder="表头名称" v-else></el-input>
            <!-- 常量没有时间粒度 -->
            <span style="margin: 0 5px 0 5px" v-if="items.dataType == 1">数值类型:</span>
            <el-select v-if="items.dataType == 1" v-model="items.math" placeholder="请选择" clearable>
              <el-option v-for="(item, index) in mathData" :key="index" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <!-- 公式 -->
            <span style="margin: 0 5px 0 5px" v-if="items.dataType == 0" class="computer" @click="
                  formula(index, rightTitle == '编辑横向表头' ? true : false)
                ">公式</span>
            <!-- <label v-if="items.dataType==0" >111</label> -->
            <el-button type="text" icon="el-icon-remove" title="删除" @click="deleteForm(index)" v-if="showadd"></el-button>
          </div>
        </div>
        <div class="addRow1" @click="addForm" v-if="showadd">
          <i class="el-icon-plus"></i>新增横向表头
        </div>
        <div style="margin-left: 330px; margin-top: 10px">
          <el-button type="primary" @click="saveRight">确定</el-button>
          <el-button style="margin-right: 15px" @click="showRight = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 右边表格新增编辑結束 -->
      <!-- 公式弹窗 -->
      <el-dialog :title="formulaTitle" :visible.sync="formulaShow" width="800px" :close-on-click-modal="false">
        <!-- <el-form label-width="100px" :rules="rules" :model="formulaForm"  ref="leftForm" v-if="formulaShow"> 
                <el-form-item label="报表标题:" prop="name" style="width:310px;margin-bottom:30px">
                    <el-input  v-model="leftForm.name"></el-input>
                </el-form-item>  
                <el-form-item >
                    <el-button type="primary" @click="saveOFrmula">确定</el-button>
                    <el-button style="margin-right:15px" @click="formulaShow = false">取消</el-button>
                </el-form-item>
            </el-form> -->
        <div>
          <el-input type="textarea" v-model="formulaValue"></el-input>
        </div>
        <div>
          <!-- <el-button type="primary" @click="saveOFrmula">确定</el-button> -->
          <span class="js" @click="tabComputer('+')"> + </span>
          <span class="js" @click="tabComputer('-')"> - </span>
          <span class="js" @click="tabComputer('*')"> × </span>
          <span class="js" @click="tabComputer('/')"> ÷ </span>
          <span class="js"> 验证公式 </span>
        </div>
        <div style="margin-bottom: 10px">
          <div style="font-size: 20px; font-weight: 600">数据项</div>
          <div style="display: flex; flex-wrap: wrap">
            <span class="js" v-for="(item, index) in columnsData" :key="index" @click="tabSum(index)">
              {{ item.title }}
            </span>
          </div>
        </div>
        <el-button @click="saveOFrmula" style="margin-left: 300px">保存</el-button>
      </el-dialog>
      <!-- 公式修改 -->
    </div>
    <div class="half">
      <div class="title-wrap zt">
        <div class="flex-1 title-content">竖向表头</div>
        <div style="flex: 0 0 130px;">
          <el-button type="primary" icon="el-icon-circle-plus" @click="addTableHeader">新增</el-button>
        </div>
      </div>
      <div class="list zt">
        <div class="item" v-for="(item, index) in rowsData" :key="index" :class="isRow == index ? 'item btn' : 'item'" @click="selectRow(index)">
          <div class="item-title" :title="item.measureName" :class="isRow == index ? 'black' : ''">
            {{ item.measureName }}
          </div>
          <div>
            <!-- <el-button type="text" icon="el-icon-edit" title="修改" @click="modifyVertical(item)"></el-button> -->
            <el-button type="text" icon="el-icon-delete" title="删除" @click="deleteTable('bottom', index)" :class="isRow == index ? 'black' : ''"></el-button>
          </div>
        </div>
        <!-- 右下角表格新增编辑开始 -->
        <el-dialog :title="verticalTitle" :visible.sync="vertical" :close-on-click-modal="false" width="550px">
          <div style="maxHeight">
            <div style="display: flex" class="rows" v-for="(items, index) in verticalFormData" :key="index">
              <label style="margin-right: 5px" width="200px">纵向表头:</label>
              <!-- :disabled="item.disabled" -->
              <el-input v-model="items.measureName" style="width: 250px" placeholder="表头名称" :disabled="items.disabled"></el-input>
              <el-button type="primary" @click="addMeasure(index)" style="margin: 0 5px 0 10px">选择视图</el-button>
              <el-button type="text" icon="el-icon-remove" title="删除" @click="deleteVertical(index)" v-if="showVertical"></el-button>
            </div>
          </div>
          <div class="addRow" @click="addVertical" v-if="showVertical">
            <i class="el-icon-plus"></i>新增纵向表头
          </div>
          <div class="verticalSave">
            <el-button type="primary" @click="saveVertical">确定</el-button>
            <el-button style="margin-right: 15px" @click="vertical = false">取消</el-button>
          </div>
        </el-dialog>
        <!-- 右边表格新增编辑結束 -->
        <!-- 视图弹窗-->
        <el-dialog title="选择视图节点" :visible.sync="showMeasure" width="700px" :close-on-click-modal="false">
          <div style="
                padding: 6px;
                background: #409eff;
                color: #fff;
                text-align: left;
              ">
            视图列表：
            <el-select style="width: 140px" size="mini" v-model="objId">
              <el-option v-for="(item, index) in viewData" :key="index" :value="item.id" :label="item.displayName"></el-option>
            </el-select>
            <el-input v-model="searchNode" placeholder="按名称搜索节点" class="serch"></el-input>
          </div>
          <div class="tree-con">
            <!-- show-checkbox -->
            <!-- @node-click="leftTreeClick" -->
            <el-tree :data="treeData" node-key="id" ref="tree" @node-click="leftTreeClick" :check-strictly="true" default-expand-all :highlight-current="true" :expand-on-click-node="false" :filter-node-method="filterNode" class="treeBox">
              <span class="custom-tree-node" slot-scope="{ data }">
                <span class="node-label">{{ data.measureName }}</span>
              </span>
            </el-tree>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable";
import tree from "@/utils/tree";
import * as fpg from "@/utils/fpg.js";
import computer from "@/utils/computer.js";
import DateTool from "@/utils/dateTool";
export default {
  components: { NkTable },
  data () {
    return {
      tableData: [],
      columns: [
        {
          label: "序号",
          fixed: "left",
          show: true,
          width: "100",
          type: "index",
          align: "center",
        },
      ],
      columnsIndex: null, //横向表头索引
      leftTable: [],
      isSelect: 0,
      isCloumn: 100000 /* 横向表头一开始默认不选择任何节点 */,
      isRow: 100000 /* 纵向表头一开始默认不选择任何节点 */,
      rowsData: [],
      columnsData: [],
      showLeft: false,
      leftTitle: "新增报表标题",
      searchNode: "",
      leftForm: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["blur", "change"],
          },
        ],
        title: [
          {
            required: true,
            message: "请选择规则",
            trigger: ["blur", "change"],
          },
        ],
      },
      showRight: false,
      rightTitle: "新增横向表头",
      rightFormData: [
        {
          title: "",
          type: "",
          math: "default",
          dataType: 1,
        },
      ],
      showadd: true,
      verticalTitle: "新增纵向表头",
      vertical: false,
      showVertical: true,
      verticalFormData: [
        {
          value: 0,
          disabled: true,
          measureName: "",
        },
      ],
      viewData: [],
      showMeasure: false,
      treeData: [],
      newTreeData: [],
      newTree: [],
      objId: null,
      viewIndex: null,
      tableType: window.baseConfig.collectData, //表类型
      datasType: [
        { id: 0, name: "常量" },
        { id: 1, name: "表达式" },
      ],
      mathData: [
        { value: "default", name: "默认" },
        { value: "max", name: "最大" },
        { value: "min", name: "最小" },
        { value: "samePeriod", name: "同期" },
        { value: "lastPeriod", name: "环期" },
      ],
      statementId: 0,
      statementName: "",
      formulaShow: false,
      formulaTitle: "公式计算",
      formulaForm: {},
      formulaValue: "",
      formulaIndex: "",
      configColumns: [],
    };
  },
  created () {
    this.tableType;
    let arr = [];
    for (let i = 0; i < this.tableType.length; i++) {
      let item = this.tableType[i];
      if (!item.show) {
        arr.push(item);
      }
    }
    this.tableType = JSON.parse(JSON.stringify(arr));
    this.getData();
  },
  mounted () { },
  watch: {
    objId (val) {
      this.getViewTreeNodes(val);
    },
    /* 搜索节点 */
    searchNode (val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    //获取表格格式数据
    async init (data) {
      let vm = this;
      console.log('进入v1.0版本报表')
      vm.rowsData = [];
      vm.columnsData = [];
      let rows = data.rows;
      vm.configColumns = data.columns;
      let columns = data.columns;
      // console.log(computer.trtdToExp())
      if (data.rows.length > 0) {
        let res1 = await vm.$api.measure.getMeasuresInfo(data.rows);
        //竖向表头
        rows.forEach((item, i) => {
          vm.rowsData.push({
            measureName: "",
            value: item,
          });
          let temp = res1.data.find((obj) => {
            return item == obj.id;
          });
          if (temp) {
            vm.rowsData[i].measureName = temp.name;
          }
        });
      }

      //获取横向表头数据
      columns.forEach((item) => {
        vm.columnsData.push({
          title: item.name,
          type: item.defaultValue.value,
          dataType: item.defaultValue.style,
          math: item.defaultValue.math,
        });
      });
    },
    /* 树搜索 */
    filterNode (value, data) {
      if (!value) return true;
      return data.measureName.indexOf(value) !== -1;
    },
    getData () {
      this.getCompanyViewTreesInfo();
    },
    //加载视图列表数据
    async getCompanyViewTreesInfo () {
      let vm = this;
      let res = await vm.$api.view.getCompanyViewTreesInfo(
        this.$store.state.user.currentCompanyId
      );
      if (res) {
        vm.viewData = res.data;
        if (res.data.length > 0) {
          vm.objId = res.data[0].id;
          vm.getViewTreeNodes(vm.objId);
        }
      }
    },
    //获取视图数据
    getViewTreeNodes (id) {
      this.$api.view.getViewTreeNodes(id).then((res) => {
        let data = tree.creatTreeJson(res.data, 0);
        this.newTree = res.data;
        this.treeData = data;
        this.newTreeData = data;
        this.putTree = [];
      });
    },
    noData () {
      this.tableData = [];
      this.columns = [
        {
          label: "序号",
          fixed: "left",
          show: true,
          width: "100",
          type: "index",
          align: "center",
        },
      ];
    },
    deleteForm (index) {
      this.rightFormData.splice(index, 1);
    },
    //设置表格格式数据
    async setUserDefinedStatements () {
      let vm = this;
      let isSuccess = false;
      let arr = {
        columns: [],
        rows: [],
      };
      vm.rowsData.forEach((item) => {
        arr.rows.push(item.value);
      });
      vm.columnsData.forEach((item) => {
        arr.columns.push({
          name: item.title,
          defaultValue: {
            style: item.dataType,
            value: item.type,
            math: item.math,
          },
        });
      });

      vm.$emit('save', arr)
    },
    /* 选择报表 */
    selectBtn (i, row) {
      this.isSelect = i;
      this.isCloumn = 1000;
      this.isRow = 1000;
      this.statementId = row.id;
      this.statementName = row.name;
      this.getUserDefinedStatementConfig();
    },
    /* 选择横向表头 */
    selectCloumn (i) {
      this.isCloumn = i;
    },
    /* 选择纵向表头 */
    selectRow (i) {
      this.isRow = i;
    },
    /* 新增左边报表 */
    addLeft () {
      this.leftForm.name = "";
      this.leftForm.id = "";
      this.leftTitle = "新增报表标题";
      this.showLeft = true;
    },
    /* 左边编辑报表 */
    modifyLeft (row) {
      this.leftTitle = "编辑报表标题";
      this.leftForm = JSON.parse(JSON.stringify(row));
      this.showLeft = true;
    },
    /* 保存左边报表 */
    saveLeft () {
      let vm = this;
      let msg = "";
      if (vm.leftTitle == "新增报表标题") {
        vm.$api.statement.createUserDefinedStatement(0, vm.leftForm.name)
          .then((res) => {
            if (res.success) {
              vm.$message.success(res.msg);
              vm.getUserDefinedStatements();
              vm.showLeft = false;
            }
          });
      } else {
        vm.$api.statement.modifyUserDefinedStatement(vm.leftForm.id, vm.leftForm.name)
          .then((res) => {
            if (res.success) {
              vm.$message.success(res.msg);
              vm.getUserDefinedStatements();
              vm.showLeft = false;
            }
          });
      }
    },
    /* 删除左右边报表 */
    deleteTable (type, i) {
      let vm = this;
      let msg = "";
      if (type == "left") {
        msg = "此操作将删除您选中的报表, 是否继续?";
      } else if (type == "right") {
        msg = "此操作将删除您选中的横向表头, 是否继续?";
      } else {
        msg = "此操作将删除您选中的纵向表头, 是否继续?";
      }
      this.$confirm(msg, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (type == "left") {
            vm.$api.definedStatement
              .deleteUserDefinedStatement(vm.statementId)
              .then((res) => {
                if (res.success) {
                  vm.$message.success(res.msg);
                  vm.getUserDefinedStatements();
                }
              });
          } else if (type == "right") {
            vm.columnsData.splice(i, 1);
            let a = vm.setUserDefinedStatements();
          } else {
            vm.rowsData.splice(i, 1);
            let a = vm.setUserDefinedStatements();
          }
          // vm.$message.success("删除成功")
        })
        .catch(() => { });
    },
    closeLeft () {
      this.$refs["leftForm"].resetFields();
    },
    /* 新增右边报表 */
    addRight () {
      this.rightFormData = [
        {
          type: "",
          title: "",
          math: "default",
          dataType: 1,
        },
      ];
      this.showadd = true;
      this.rightTitle = "新增横向表头";
      this.showRight = true;
    },
    /* 修改数据类型 */
    changeData (i, value) {
      this.rightFormData[i].type = "";
    },
    /* 修改数据项 */
    changeColle (i, value) { },
    /* 点击公式 */
    formula (i, isEdit) {
      let obj = null;
      obj = JSON.parse(JSON.stringify(this.rightFormData[i]));

      let str = obj.type;
      console.log(str.match("exp=*"))
      if (str.match("exp=*")) {
        this.formulaValue = str.replace("exp=", "");
      } else {
        this.formulaValue = "";
      }
      this.formulaIndex = i;
      this.formulaShow = true;
    },
    /* 加减乘除 */
    tabComputer (type) {
      let computer = null;
      this.formulaValue += type;
      console.log(this.formulaValue);
    },
    /* 数据项点击 */
    tabSum (i) {
      this.formulaValue += "d" + i;
      console.log(this.formulaValue);
    },
    /* 公式保存 */
    saveOFrmula () {
      this.formulaValue.replace("exp=", "");
      this.rightFormData[this.formulaIndex].type = "exp=" + this.formulaValue;
      this.formulaShow = false;
    },
    /* 右边编辑报表 */
    modifyRight (row, i) {
      console.log(row);
      this.columnsIndex = i;
      this.showadd = false;
      this.rightTitle = "编辑横向表头";
      this.rightFormData = JSON.parse(JSON.stringify([row]));
      this.showRight = true;
    },
    /* 保存右边报表 */
    saveRight () {
      let vm = this;
      let msg = "";
      let columnsData = JSON.parse(JSON.stringify(vm.columnsData));
      if (vm.rightTitle == "新增横向表头") {
        let ifK = true;
        vm.rightFormData.forEach((item, key) => {
          if (item.title === "") {
            ifK = false;
          }
          columnsData.push(item);
        });
        if (ifK) {
          vm.columnsData = JSON.parse(JSON.stringify(columnsData));
          this.setUserDefinedStatements();
          vm.showRight = false;
        } else {
          vm.$message.warning("表头名称不能为空");
          return false;
        }
      } else {
        vm.columnsData[vm.columnsIndex] = vm.rightFormData[0];
        vm.setUserDefinedStatements();
        vm.showRight = false;
      }
    },
    deleteVertical (i) {
      this.verticalFormData.splice(i, 1);
    },
    addForm () {
      this.rightFormData.push({
        title: "",
        type: "",
        math: "default",
        dataType: 1,
      });
    },
    //新增竖向表头
    addTableHeader () {
      this.verticalFormData = [
        {
          value: 10,
          measureName: "",
          disabled: true,
        },
      ];
      this.vertical = true;
      this.verticalTitle = "新增纵向表头";
      this.showVertical = true;
    },
    //添加计量点
    addMeasure (i) {
      this.showMeasure = true;
      this.searchNode = "";
      this.viewIndex = i;
    },
    leftTreeClick (data) {
      let vm = this;
      this.verticalFormData[this.viewIndex].measureName = data.measureName;
      this.verticalFormData[this.viewIndex].value = data.measureId;
      this.verticalFormData[this.viewIndex].disabled = false;
      this.showMeasure = false;
    },
    addVertical () {
      this.verticalFormData.push({
        value: "",
        measureName: "",
        disabled: true,
      });
    },
    /* 纵向表头编辑 */
    modifyVertical (row) {
      let vm = this;
      vm.showVertical = false;
      vm.verticalTitle = "编辑纵向表头";
      vm.verticalFormData = JSON.parse(JSON.stringify([row]));
      vm.vertical = true;
    },
    /* 保存纵向表头 */
    saveVertical () {
      let vm = this;
      let msg = "";
      let rowsData = JSON.parse(JSON.stringify(vm.rowsData));
      if (vm.verticalTitle == "新增纵向表头") {
        let ifK = true;
        vm.verticalFormData.forEach((item, key) => {
          if (item.measureName === "") {
            ifK = false;
          }
          rowsData.push(item);
        });
        if (ifK) {
          vm.rowsData = JSON.parse(JSON.stringify(rowsData));
          vm.setUserDefinedStatements();
          vm.vertical = false;
        } else {
          vm.$message.warning("表头名称不能为空");
          return false;
        }
      } else {
        msg = "编辑成功";
      }
    },
  },
};
</script>
<style lang="css" scoped>
.serch {
  margin-left: 20px;
  width: 200px;
}
.serch >>> .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 30px;
  line-height: 30px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
</style>
<style lang="scss" scoped>
.btn {
  background: #5fa4e8;
  color: #fff !important;
}
.black {
  color: #fff;
}
.report-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  .left {
    // flex: 0 0 300px;
    width: 300px;
    height: 100%;
    padding: 7px;
    box-sizing: border-box;
    .left-btn {
      width: 100%;
      height: 40px;
    }
    .list {
      color: #000;
      height: calc(100% - 40px);
      overflow: auto;
      .item {
        display: flex;
        align-items: center;
        border: 1px solid;
        padding: 0px 6px;
        margin-top: 10px;
        cursor: pointer;
        border-radius: 4px;
        .item-title {
          width: 240px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .flex-1 {
    flex: 1;
  }
  .content {
    margin: 0px 14px;
    padding: 0px 6px;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    width: calc(100% - 700px);
  }
  .right {
    // flex: 0 0 400px;
    width: 100%;
    height: 100%;
    padding: 0px 6px;
    overflow: hidden;
    box-sizing: border-box;
    .half {
      height: 50%;
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-flow: column;
      .list {
        color: #000;
        height: calc(100% - 60px);
        overflow: auto;
        .item {
          display: flex;
          align-items: center;
          border: 1px solid;
          float: left;
          padding: 0px 6px;
          margin-top: 10px;
          justify-content: space-between;
          border-radius: 4px;
          .item-title {
            width: 240px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .title-wrap {
    width: 100%;
    height: 50px;
    line-height: 40px;
    border-bottom: 1px solid rgb(214, 214, 214);
    color: #000;
    display: flex;
    padding: 4px 0px;
    align-items: center;
    .col-blue {
      width: 4px;
      height: 20px;
      background: rgb(101, 128, 216);
      margin-right: 6px;
    }
    .title-content {
      font-weight: bold;
    }
  }
  .list1 {
    // display: flex;
    // flex: 1;
    // flex-wrap: wrap;
    color: #000;
    overflow: auto;
    .item {
      display: flex;
      float: left;
      align-items: center;
      border: 1px solid;
      padding: 0px 6px;
      margin: 5px;
      border-radius: 4px;
      .item-title {
        margin-right: 10px;
      }
    }
  }
}
.rows {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.addRow {
  margin-left: 67px;
  border: 1px dashed #797979;
  text-align: center;
  padding: 5px;
  margin-right: 87px;
  cursor: pointer;
}
.addRow1 {
  margin-left: 38px;
  border: 1px dashed #797979;
  text-align: center;
  padding: 5px;
  margin-right: 18px;
  cursor: pointer;
}
.maxHeight {
  max-height: 350px;
  overflow: auto;
}
.treeBox {
  max-height: 450px;
  overflow: auto;
}
.layou-container {
  overflow: none;
  text-overflow: none;
  white-space: "";
}
.verticalSave {
  margin-left: 262px;
  margin-top: 10px;
}
.mesureName {
  max-width: 200px;
  white-space: break-spaces;
  margin-right: 7px;
}
.computer {
  margin: 0px 10px;
  color: #0097fb;
  cursor: pointer;
}
.js {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin: 6px;
}
</style>